import { render, staticRenderFns } from "./lazyImage.vue?vue&type=template&id=ffdf6202&scoped=true"
import script from "./lazyImage.vue?vue&type=script&lang=js"
export * from "./lazyImage.vue?vue&type=script&lang=js"
import style0 from "./lazyImage.vue?vue&type=style&index=0&id=ffdf6202&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffdf6202",
  null
  
)

export default component.exports